module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "section-graphs"
    }
  }, [(_vm.section.section === 'arterial-roads' || _vm.section.section === 'blocks-and-plots') ? _c('div', [_c('div', {
    staticClass: "grid change-years"
  }, [_c('div', {
    staticClass: "col-1-1"
  }, [_c('div', {
    staticClass: "change-year",
    class: {
      currentYear: !_vm.laterYear
    },
    on: {
      "click": function($event) {
        _vm.laterYear = false
      }
    }
  }, [_vm._v(_vm._s(_vm.earlyRange))]), _vm._v(" "), _c('div', {
    staticClass: "change-year",
    class: {
      currentYear: _vm.laterYear
    },
    on: {
      "click": function($event) {
        _vm.laterYear = true
      }
    }
  }, [_vm._v(_vm._s(_vm.laterRange))])])])]) : _vm._e(), _vm._v(" "), (_vm.section.section === 'population') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('population_line'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('population_change_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hold-legend col-1-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('population_change_bar'))
    }
  })])])]) : (_vm.section.section === 'urban-extent') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('urban_extent_composition_stacked_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hold-legend col-1-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('urban_extent_composition_stacked_bar'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('urban_extent_change_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hold-legend col-1-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('urban_extent_change_bar'))
    }
  })])])]) : (_vm.section.section === 'density') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('density_built_up_line', undefined, undefined))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad no-pad mob-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('density_built_up_change_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hold-legend col-1-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('density_built_up_change_bar'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('density_urban_extent_line', undefined, undefined))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('density_urban_extent_change_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hold-legend col-1-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('density_urban_extent_change_bar'))
    }
  })])])]) : (_vm.section.section === 'composition-of-added-area') ? _c('div') : (_vm.section.section === 'roads') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('roads_in_built_up_area_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('roads_in_built_up_area_bar'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('roads_average_width_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('roads_average_width_bar'))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('roads_width_stacked_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('roads_width_stacked_bar'))
    }
  })])])])]) : (_vm.section.section === 'arterial-roads') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('arterial_roads_density_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('arterial_roads_density_bar'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('arterial_roads_walking_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('arterial_roads_walking_bar'))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('arterial_roads_beeline_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('arterial_roads_beeline_bar'))
    }
  })])])])]) : (_vm.section.section === 'blocks-and-plots') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('blocks_and_plots_composition_special_stacked', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('blocks_and_plots_composition_special_stacked'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('blocks_plots_average_block_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('blocks_plots_average_block_bar'))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('blocks_plots_average_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('blocks_plots_average_bar'))
    }
  })])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0667304c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Graphs.vue
// module id = 295
// module chunks = 1